import urlBuilder from "./urlBuilder";
import getUmbracoEndPoint from "./UmbracoEndPoint";

export default async (route: string): Promise<any[]> => {
    const url = urlBuilder("/api/tags", { url: route });

    const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: undefined
    });

    return await response.json();
};